import React from "react";
import {ArenaBaseModel} from "../arena-base.model";
import {
    ArenaConfiguration, ArenaGamesGridConfiguration,
    SwiperGamesListConfiguration
} from "../../../../configurations/config-data-sections/arenas.configuration";
import {CasinoArenaComponent} from "../../../../../components/arena-host/casino-arena/casino-arena.component";

export class CasinoLobbyArenaModel extends ArenaBaseModel {

    get maxSwipersToShow(): number {
        return 20;
    }

    get maxGamesToShowInList(): number {
        return 30;
    }

    private get config(): ArenaConfiguration {
        return this.services.configuration.data.arenas[this.arenaName]
    }

    protected _getSwipersConfigurations(): SwiperGamesListConfiguration[] {
        return this.config.swiperGamesList || [];
    }

    protected _getGridsConfigurations(): ArenaGamesGridConfiguration[] {
        return this.config.allGamesGrid || [];
    }

    renderArena(): React.ReactElement | null {
        return <CasinoArenaComponent key={this.arenaName} arenaName={this.arenaName}/>;
    }

    protected _getPromotionalBannerConfig() {
        const bannerConfig = this.config.promotionalBanner;
        if(!bannerConfig) {
            return null;
        }

        if(this.services.device.hybrid.isEmbedded) {
            return null;
        }

        return {
            position: 2,
            templateID: bannerConfig.templateID,
            componentID: bannerConfig.componentID,
            fallbackComponent: bannerConfig.fallbackComponent,
            bannerAdminPlaceholderId: bannerConfig.bannerAdminPlaceholderId
        }
    }
}
